import { put, call, take, fork } from 'redux-saga/effects'
import { courseAddService } from '../../api/course'
import { courseAddSuccess } from '../../reducers/course/action'
import { COURSE_ADD } from '../../reducers/course/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* courseAddFlow(payload) {
  try {
    const { entity, callback } = payload

    const response = yield call(courseAddService, entity)

    yield put(courseAddSuccess(response.data))
    yield put(operationSuccess())
    callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* courseAddWatcher() {
  while (true) {
    const action = yield take(COURSE_ADD)
    const { payload } = action

    yield fork(generalSaga, courseAddFlow, payload)
  }
}
